export const ProductsDatabase = [
  {
    id: 1,
    imageSrc:
      "https://i.etsystatic.com/20383773/r/il/701d06/3082248471/il_794xN.3082248471_220d.jpg",
    productName: "Maya - Modern Polymer Clay earrings",
    description: `HYPOALLERGENIC, NICKEL FREE, LIGHTWEIGHT
    
    *CARE*
    Handle with care and keep out of reach of children and pets.
    To clean take a damp towel and wipe them gently.
    You may use soap if you would like! But I still highly recommend handling with care!
    
    Please message me with any details!
    
    And don't forget to follow my instagram page for the latest updates on any new items!
    https://www.instagram.com/amanocraftstudio/
    
    If you provide a gift message, I will ensure this message be printed and displayed in the packaging to show the recipient who to thank!`,
    price: 2450,
    originalPrice: 3999,
    newFlag: true,
    seller: "Amano Craft Studio"
  },
  {
    id: 2,
    imageSrc:
      "https://i.etsystatic.com/25946754/r/il/7dce05/2808308044/il_794xN.2808308044_7zjv.jpg",
    productName: "Rainbow Earrings,",
    description: `Hello and welcome!

    If you are looking for elegant, bold and unique earrings that fit for every occasion, you are in the right place :)
    
    Handcrafted with love; every peace is truly handmade, starting with manually mixing colors, modelling the clay, sanding and assembling(I even do my own cutters).
    
    -Hypoallergenic stainless steel studs
    -Ultra Lightweight and comfortable
    -Large statement rainbow earrings in light pastel colors, magnet for compliments :)
    
    ▸▸▸SHIPPING:
    - I use Deutsche Post for national and international orders and all items will be wrapped and secured
    DE: FREE Standard Shipping, 2-5 days
    EU: Priority Standard Shipping(without tracking number), 5-15 days
    🡣🡣🡣
    Low cost delivery with Standard Shipping option will keep postage/shipping costs to a minimum, unless you choose Registered tracking delivery upon checkout.
    
    USA,Switzerland and other international countries: Registered Priority Shipping (tracking number included in the shipping price), 15-30 days (or more until the pandemic is over)
    
    
    
    Each piece is unique and due to handmade nature, colors and design may vary a little.
    I will do my best to ensure your jewelry arrives to you safe and beautiful, but if you have any problems with your order please contact me.
    
    Thank you for visiting my shop <3
    http://studioniani.etsy.com
    You can also visit my Instagram to check for updates, or to say hello :)
    https://www.instagram.com/studioniani`,
    price: 3500,
    originalPrice: 4999,
    newFlag: false,
    seller: "Studio Niani"
  },
  {
    id: 3,
    imageSrc:
      "https://i.etsystatic.com/23514472/r/il/f0b791/2777175134/il_794xN.2777175134_ckty.jpg",
    productName: "One Line Art Metal Wall Art Decoration",
    description: `Color: Textured, Black Paint

    Material: 2 mm steel
    
    Product Dimensions : 38.97” X 27” Inches
    
    Product Dimensions : 99 cm X 69 cm
    
    Product stands 2 cm (0.78") away from the wall .
    
    Easy to hang from hidden hanger. You just need a nail on the wall for each piece. Easy to Use and Ready to Hang Wall Decoration
    
    Best gift suitable for any occassion (Birthday, Anniversary, Valentines, House warming, Christmas etc).
    
    Suitable for INDOOR AND OURDOOR USE
    
    EYE-CATCHING MODERN WALL DECOR: One Line/ Single Line Metal Wall Decor is a set of wire geometric metal hanging wall decoration is an inspirational wall art for living room, bedroom, dining room, kitchen and for your entire home.
    
    SATISFACTION GUARANTEED OR YOUR MONEY BACK: We are committed to the highest levels of quality and excellence and stand behind every product we make. We know you’re going to love your purchase but if you’re not completely thrilled for any reason (or even no reason at all), simply contact us within 30 days of receiving your order and we’ll happily resolve the matter or issue.
    
    MAXPAMSER PROMISE: As with all of our products, Bekata guarantees the best price for the best possible quality and fastest delivery on all orders
    
    WORLD WIDE DELIVERIES : All orders are delivered to your address in 2-3 business days by DHL and UPS`,
    price: 4500,
    originalPrice: 5000,
    newFlag: false,
    seller: "Maxpamser"
  },
  {
    id: 4,
    imageSrc:
      "https://i.etsystatic.com/23675379/r/il/ed6145/2583221457/il_794xN.2583221457_6cgc.jpg",
    productName: "Metal Yard Art - Garden Wall Art",
    description: `FREESHIPPING WORLWIDE VIA DHL OR FEDEX

    1 SET (7 PCS BIRDS)
    2 SET (14 PCS BIRDS)
    3 SET (21 PCS BIRDS)
    
    Hello! Welcome to my shop!
    
    I working on metal home art!
    
    7 PCS BIRD SET Product Size:
    - 20x21 cm (1pc),
    - 16x16 cm (2pcs),
    - 20x17 cm (2pcs),
    - 20x16 cm (2pcs)
    
    Tickness: 2 mm
    
    Color: Grey- Electro Static Powder Coating`,
    price: 5299,
    originalPrice: 6400,
    newFlag: true,
    seller: "Garden Metal Art"
  },
  {
    id: 5,
    imageSrc:
      "https://i.etsystatic.com/18708368/r/il/912d11/2226553829/il_794xN.2226553829_qfrp.jpg",
    productName: "Granite Brown Earrings",
    description: `Unusual handmade earrings are made of polymer clay. Easy and interesting.Handmade earrings, each unique and one of a kind.These jewelry will make your day more fun and bright.All of my earrings are handmade so please expect some small flaws, irregular shapes, visible paint strokes and so on.
    I believe that this adds character to each and every pair of earrings!Please understand that there may be small flaws, small defects are inevitableColors and pattern may vary slightly.
    `,
    price: 2479,
    originalPrice: 3500,
    newFlag: false,
    seller: "BrightStyleByLori"
  },
  {
    id: 6,
    imageSrc:
      "https://i.etsystatic.com/16223767/r/il/c9dee2/2505289785/il_794xN.2505289785_c76l.jpg",
    productName: "Lavender Floral Pattern Circle Earrings",
    description: `Hi there! Welcome to Shaelyn Designs!

    These super cute lavender patterned dangles are a personal fave of mine and are sure bring a little joy on even the greyest of days. They are made with hypoallergenic ear wires which are perfect for sensitive ears (and won’t leave any green stains!). Polymer clay is a strong, super light, and slightly flexible material meaning all our earrings are durable and comfortable enough to be shown off all day ;)
    
    These earrings are Handmade from polymer clay, they measure 4cm in length and are 2.5cm at the widest point.`,
    price: 5450,
    originalPrice: 7000,
    newFlag: false,
    seller: "ShaelynDesignsStore"
  },
  {
    id: 7,
    imageSrc:
      "https://i.etsystatic.com/27293392/r/il/6bd30d/2873863242/il_794xN.2873863242_poqt.jpg",
    productName: "Polymer clay earrings",
    description: `Handmade polymer clay earrings.

    Room color size 1.2 cm
    
    Brass connector, 2 cm size
    
    They're chic! and an ideal gift for women :)
    
    Disinfected jewelry before protected mailing and in letter followed`,
    price: 4500,
    originalPrice: 5699,
    newFlag: true,
    seller: "ViolaBBijoux"
  },
  {
    id: 8,
    imageSrc:
      "https://i.etsystatic.com/21249136/r/il/ade528/3012166116/il_794xN.3012166116_4ps0.jpg",
    productName: "The Hinata: Eclectic Minimal Mango",
    description: `A perfect understated statement piece to complete any look!

    These Hypoallergenic, Ultra Lightweight Eclectic Minimal Mango Orange/Yellow Hypoallergenic Polymer Clay Squiggle Statement Earrings Details are set on to 14k gold filled hooks
    
    Of Clay Jewelry is always lightweight, hypoallergenic, and lead and nickel free!`,
    price: 3479,
    originalPrice: 4299,
    newFlag: true,
    seller: "OfClay"
  },
  {
    id: 9,
    imageSrc:
      "https://i.etsystatic.com/25298356/r/il/f80d50/3077554669/il_794xN.3077554669_mchh.jpg",
    productName: "Polymer clay earrings",
    description: `Sage - These polymer clay flower dangle earrings, are perfect for any occasion.


    - Brass hardware
    - acrylic Flower features
    - polymer clay
    
    Sterling silver s925 posts
    
    Please note that each earring is handmade, therefore there will be some slight variations in size and colour. Making each one unique in its own way.`,
    price: 1479,
    originalPrice: 2999,
    newFlag: true,
    seller: "Cherry Casa"
  },
  {
    id: 10,
    imageSrc:
      "https://i.etsystatic.com/27293392/r/il/6bd30d/2873863242/il_794xN.2873863242_poqt.jpg",
    productName: "Boho Jewellery - Dangle Earrings",
    description: ` Handmade polymer clay earrings. Stud post fixing, 100% nickel and lead free. Sterling Silver is available, please pick when adding to your basket.
    - 3.5cm tall x 2.2cm wide
    
    - Made from super lightweight polymer clay
    
    - FREE UK SHIPPING
    ______
    
    Each pair of earrings is handmade and unique! I make each pair from start to finish in my small home studio in Portsmouth. All are original pieces and therefore may have small blemishes that make them unique. All are produced with lots of love and care from start to finish!
    ______
    
    CARE:
    To help your earrings please store in a clean, dry place. Use of oils, creams, perfumes and other substances may affect longevity. Do not wear in water. Please treat these earrings as you would any other piece of jewellery!`,
    price: 479,
    originalPrice: 999,
    newFlag: false,
    seller: "LunaGreyStudio"
  }
];
